export const VossCreditBehaviour = {
    Prorate: 0,
    Full: 1,
    None: 2
}

export const VossCreditBehaviourText = {
    [VossCreditBehaviour.Prorate]: "vossCreditBehaviour.prorate",
    [VossCreditBehaviour.Full]: "vossCreditBehaviour.full",
    [VossCreditBehaviour.None]: "vossCreditBehaviour.none"
}